import { Content, Badge } from './rack-event.styled';

export const RackEvent = (props) => {
  const { data, type, showWindow } = props;
  const active = data.active;

  return (
    <Content type={type} $active={active} onClick={() => showWindow()}>
      {active && <Badge type={type} />}
    </Content>
  );
};
